import { useEffect, useState } from 'react';
import { SelectedOptionValue } from 'react-select-search';
import { IntlType } from '../../../../../utils/typing';
import { Site } from '../../../../site-selection/models';
import { Formik } from '../../../hooks/useForm';
import { FormSelections } from '../hooks/useFormSelections';
import SelectedSitesList from '../UserForm/SelectedSitesList';
import SiteSelectorInput from '../UserForm/SiteSelectorInput';
import { SearchOption } from '../UserForm/SiteSelector';

interface Props {
  intl: IntlType;
  formSelections: FormSelections;
  formik: Formik;
}

const CashierSiteSelector = ({ intl, formSelections, formik }: Props): JSX.Element => {
  const [searchOptions, setSearchOptions] = useState<SearchOption[]>([]);
  const [selectedSites, setSelectedSites] = useState<Site[]>([]);

  useEffect(() => {
    if (
      formik.values.cashierSites &&
      formik.values.cashierSites.length > 0 &&
      formSelections.sites.length > 0
    ) {
      const initialSelectedSites = formSelections.sites.filter((site) =>
        formik.values.cashierSites.some((cashierSite) => cashierSite.id === site.id)
      );
      setSelectedSites(initialSelectedSites);
    }
  }, [formik.values.cashierSites, formSelections.sites]);

  useEffect(() => {
    const availableSites = formSelections.sites.filter(
      (site) => !selectedSites.some((selectedSite) => selectedSite.id === site.id)
    );
    setSearchOptions(
      availableSites.map((site) => ({
        name: site.name,
        value: site.id,
      }))
    );
  }, [selectedSites, formSelections.sites]);

  useEffect(() => {
    const currentFormikSites = formik.values.cashierSites || [];
    const newFormikSites = selectedSites.map((site) => ({ id: site.id }));

    const isDifferent =
      currentFormikSites.length !== newFormikSites.length ||
      currentFormikSites.some((formikSite, index) => formikSite.id !== newFormikSites[index]?.id);

    if (isDifferent && selectedSites.length > 0) {
      formik.setFieldValue('cashierSites', newFormikSites);
    }
  }, [selectedSites]);

  const addSelectedSite = (selectedSiteId: SelectedOptionValue | SelectedOptionValue[]) => {
    const site = formSelections.sites.find((s) => s.id === selectedSiteId) as Site;

    setSelectedSites([...selectedSites, site]);
    setSearchOptions(
      searchOptions.filter((option) => option.value !== (selectedSiteId as unknown as number))
    );
  };

  const removeSelectedSite = (site: Site) => {
    setSelectedSites(selectedSites.filter((s) => s.id !== site.id));
    setSearchOptions([...searchOptions, { value: site.id, name: site.name }]);
  };
  if (!formik.values.isCashier) {
    return <></>;
  }

  return (
    <div className="cashier-site-selector">
      <label htmlFor="cashierSiteSelection" className="font-weight-bold">
        {intl.formatMessage({ id: 'cashierSiteSelection' })}
      </label>

      <SiteSelectorInput
        intl={intl}
        searchOptions={searchOptions}
        addSelectedSite={addSelectedSite}
        selectedSites={selectedSites}
      />
      <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
        <SelectedSitesList
          intl={intl}
          selectedSites={selectedSites}
          removeSelectedSite={removeSelectedSite}
        />
      </div>
    </div>
  );
};

export default CashierSiteSelector;
